import { cloneDeep } from 'lodash';

export class FlowUtils {
    static cloneDeep<T>(target: T): T {
        return cloneDeep(target);
    }
}
